<anon-story-header (previewClicked)="previewStory(true)" [story]="this.story"></anon-story-header>

<ng-container *ngIf="isLoading ;else loaded">
  <anon-loading [height]="250"></anon-loading>
</ng-container>

<ng-template #loaded>
  <article>
    <anon-editor
      [config]="editorConfig"
      [story]="story.content"
      (editorChange)="onChange($event)"
    ></anon-editor>
  </article>
</ng-template>
